import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { get } from '../apis/Tools';

/**
 * Hook que obtiene las vistas visibles para el rol actual del usuario
 * Retorna un set de claves de vistas para fácil búsqueda
 */
export function useVisibleVistas() {
  const authInfo = useSelector((state) => state.Auth);
  const { currentUser } = authInfo;
  const [visibleVistas, setVisibleVistas] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUser?.role_id) {
      setVisibleVistas(new Set());
      setLoading(false);
      return;
    }

    const fetchVisibleVistas = async () => {
      try {
        setLoading(true);
        const response = await get('/v1/api/vistas/me');

        if (response?.ok && Array.isArray(response.payload)) {
          const vistasSet = new Set(
            response.payload.map((v) => v.clave.toLowerCase())
          );
          setVisibleVistas(vistasSet);
        }
        setError(null);
      } catch (err) {
        console.error('Error fetching visible vistas:', err);
        setError(err.message);
        setVisibleVistas(new Set());
      } finally {
        setLoading(false);
      }
    };

    fetchVisibleVistas();
  }, [currentUser?.role_id]);

  return { visibleVistas, loading, error };
}
